export const API_VERSION = 'v1.3'
export const BASE_URL = `https://displatform.com/demoweb/${API_VERSION}/`
